import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'theSource/app/store';

export interface DisplayPostElectionToastState {
  value: boolean;
  benefitLookupCode?: string;
}

const initialState: DisplayPostElectionToastState = {
  value: false,
  benefitLookupCode: undefined,
};

const displayPostElectionSlice = createSlice({
  name: 'postElectToast',
  initialState,
  reducers: {
    setDisplayToast: (state, { payload }: PayloadAction<boolean>) => {
      state.value = payload;
    },
    setToastBenefitLookupCode: (state, { payload }: PayloadAction<string>) => {
      state.benefitLookupCode = payload;
    },
  },
});

const { reducer, actions } = displayPostElectionSlice;

export const { setDisplayToast, setToastBenefitLookupCode } = actions;
export const selectDisplayToast = (state: RootState) => state.postElectToast.value;
export const DisplayPostElectionReducer = reducer;
